export function getSubdomain() {
  const hostname = window.location.hostname;
  return hostname.split(".")[0];
}
